// extracted by mini-css-extract-plugin
export default {"characteristic":"characteristic_characteristic__vPWk-"};